export default __webpack_public_path__ + "static/logo-header-5b47eb0bce3d73635a06f18330a35677.svg";